import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { SupplierRequestDraftItem } from '../model/types';
import RequestItemsTableBody from './RequestItemsTableBody';

interface RequestItemsTableProps {
    items: SupplierRequestDraftItem[];
    editCountIndex?: number | null;
    setEditCountIndex?: (index: number | null) => void;
    onSaveCount?: (index: number, value: string | number) => void;
    onRemove?: (index: number) => void;
    disabled?: boolean;
    showActions?: boolean;
    showReceived?: boolean;
}

const RequestItemsTable = ({
    items,
    editCountIndex = null,
    setEditCountIndex = () => undefined,
    onSaveCount = () => undefined,
    onRemove = () => undefined,
    disabled = false,
    showActions = true,
    showReceived = false,
}: RequestItemsTableProps) => {
    const { t } = useTranslation(['Warehouses']);

    return (
        <div className="crm-table-wrap">
            <Table size="sm" className="mb-0 align-middle supplier-request-items-table">
                <thead>
                    <tr className="bg-light">
                        <th>{t('supplierRequests.create.colName')}</th>
                        <th>{t('supplierRequests.create.colArticle')}</th>
                        <th className="text-end">{t('supplierRequests.create.colCount')}</th>
                        {showReceived && (
                            <th className="text-end">{t('supplierRequests.create.colReceived')}</th>
                        )}
                        {showActions && (
                            <th className="text-end">{t('supplierRequests.create.colActions')}</th>
                        )}
                    </tr>
                </thead>
                <RequestItemsTableBody
                    items={items}
                    editCountIndex={editCountIndex}
                    setEditCountIndex={setEditCountIndex}
                    onSaveCount={onSaveCount}
                    onRemove={onRemove}
                    disabled={disabled}
                    showActions={showActions}
                    showReceived={showReceived}
                />
            </Table>
        </div>
    );
};

export default RequestItemsTable;
